(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter_sorting"] && !Shopify.designMode) return;
  try {
    
  let bottom_filter = document.querySelector(".bottom_filter");
  let actual_bottom_filter = document.querySelector(".mobile-facets__open");
  bottom_filter.addEventListener("click", function(){
    actual_bottom_filter.click();
  })

  } catch(e) { console.error(e); }
})();
})();
